/*
 * @Author: your name
 * @Date: 2020-10-13 14:28:22
 * @LastEditTime: 2021-03-04 23:39:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \fp_h5\src\store\modules\devicelog\devicelog.js
 */
import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        searchP:{
            templateid:'',// 
            appid:'',
            starttime:'',// 
            endtime:'',// 
            templatenum:'',
            businesstype:'',
            paramskey:'',
            platform:'',
        },

        list: [], //table中的list显示数据
        pagination: {
            
        }, //分页相关的信息
        record: {
            devicekeyword:''
        },//
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
        }
    },

    actions: {
      
        // 微信模版 列表    
        queryWXtemplateList(context, payload){
            return D.select({
                ...payload
            })
        },
        // 微信模版 新增    
        addTemplate(context, payload){
            return D.select({
                ...payload
            })
        },
        
        // 微信模版 删除    
        deleteTemplate(context, payload){
            return D.del({
                ...payload
            })
        },
        // 微信模版 修改    
        editTemplate(context, payload){
            return D.select({
                ...payload
            })
        },

        querySmsSignApplyPageList(context, payload){
            return D.select({
                ...payload
            })
        },
        querySmsSignDetails(context, payload){
            return D.select({
                ...payload
            })
        },
        deleteSmsSignApply(context, payload){
            return D.del({
                ...payload
            })
        },
        addSmsSignApply(context, payload){
            return D.add({
                ...payload
            })
        },
        querySmsSignApplyStatus(context, payload){
            return D.select({
                ...payload
            })
        },
        editSmsSignApply(context, payload){
            return D.edit({
                ...payload
            })
        },

        querySmsTemplateApplyPageList(context, payload){
            return D.select({
                ...payload
            })
        },

        querySmsTemplateDetails(context, payload){
            return D.select({
                ...payload
            })
        },

        editSmsTemoplateApply(context, payload){
            return D.edit({
                ...payload
            })
        },

        deleteSmsTemoplateApply(context, payload){
            return D.del({
                ...payload
            })
        },

        addSmsTemoplateApply(context, payload){
            return D.add({
                ...payload
            })
        },

        querySmsTemplateApplyStatus(context, payload){
            return D.select({
                ...payload
            })
        },

        //微信模版详情
        detailTemplate(context, payload) {
            payload.apikey = 'wxtemplatemanager/detailTemplate'
            return D.detail({
                ...payload
            }).then(response => {
                const { data } = response.data;
                context.commit({
                    type: 'save',
                    payload: {
                        record: data
                    }
                })
                return response
            })

        },
      
        //清空设备管理搜索条件
        getEmptySearch(context){
            context.commit({
                type: 'save',
                payload: {
                    searchP: {
                        templateid:'',// 
                        appid:'',
                        starttime:'',// 
                        endtime:'',// 
                        templatenum:'',
                        businesstype:'',
                        paramskey:'',
                        platform:'',
                    }
                }
            })
        },  

    }
    
}